/* @flow */
import { Map, Set, fromJS } from 'immutable';
import { OrderedMap, List } from 'immutable';
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { sortBy } from 'trustar/utils/utils.js';

export const saved = getterFromKeyPath(['analyses', 'saved']);

export const shared = getterFromKeyPath(['analyses', 'shared']);

export const filters = getterFromKeyPath(['analysesMeta', 'filters']);

export const loading = getterFromKeyPath(['analysesMeta', 'loading']);

export const savedAnalyses = createSelector(
  saved,
  (analyses: OrderedMap<any, any>): List<*> =>
    analyses
      .sort(sortBy('created', 'ASC'))
      .toList(),
);

export const sharedAnalyses = createSelector(
  shared,
  (analyses: OrderedMap<any, any>): List<*> =>
    analyses
      .sort(sortBy('created', 'ASC'))
      .toList(),
);

export const analysis = (guid: ?string) => {
  return createSelector(
    [ saved, shared ],
    (saved: OrderedMap<any, any>, shared: OrderedMap<any, any>) => {
      // Why do we simply return a Map with a title property? What about all
      // the other properties???
      if (shared.get(guid)) {
        return fromJS({ 'title': shared.getIn([guid, 'title']) });
      }

      return saved.get(guid);
    },
  );
};

export const analysisMap = createSelector(
  [ saved, shared, filters ],
  (saved: OrderedMap<any, any>, shared: OrderedMap<any, any>, filters: Set<any>) => {
    let result = Map();
    if (filters.size === 0) {
      return List();
    } else if (filters.size === 2) {
      result = saved.merge(shared);
    } else if (filters.includes('saved')) {
      result = saved;
    } else if (filters.includes('shared')) {
      result = shared;
    }
    return result
      .sort(sortBy('created', 'ASC'))
      .toList();
  },
);



// WEBPACK FOOTER //
// ./src/app/modules/analysis/getters.js